export const RESET_VOTING_FORM = "VOTING_FORM/RESET";
